import React from "react";
import {UserState} from "../../../../Redux/Types";
import Button, {ButtonColor} from "../../Button/Button";
import {deleteAccount} from "../../../../API/Calls";
import {Link} from "react-router-dom";
import styles from "./Delete.module.scss";

interface Props {
    user: UserState | null
    closeFunction: () => void;
    logout: () => void;
}

interface State {
    loading: boolean,
    errorMessage?: string;
    abort: AbortController;
}

export default class Delete extends React.Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props);

        this.state = {
            loading: false,
            abort: new AbortController()
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                {
                    this.state.errorMessage ? <div className={"AuthError"}>{this.state.errorMessage}</div> : ""
                }
                <div className={styles.DeleteForm}>
                    <p>
                        Are you sure you want to delete your wavy.fm account? Please refer to
                        our <Link to={"/privacy"}>Privacy Policy</Link> to review what information will be purged.
                    </p>
                    <p className={styles.Danger}>
                        This deletion cannot be undone.
                    </p>
                    <div className={"FormField " + styles.FormField}>
                        <label htmlFor={"Password"}>
                            Confirm with your password
                        </label>
                        <input required={true} name={"Password"} type={"password"}
                               autoComplete={"off"}/>
                    </div>
                    <div className={"FormField SubmitRegion " + styles.FormField + " " + styles.SubmitRegion}>
                        <Button color={ButtonColor.Regular}
                                onClick={() => this.props.closeFunction()}>Cancel</Button>
                        <Button form={true} color={ButtonColor.Danger} disabled={this.state.loading}>Delete</Button>
                    </div>
                </div>
            </form>
        )
    }

    handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        if (this.state.loading || !this.props.user) {
            return;
        }

        const password = ((event.target as HTMLFormElement).elements.namedItem("Password") as HTMLInputElement).value;
        if (!password || !password.trim()) {
            return;
        }

        this.setState({loading: true, errorMessage: undefined}, () => {
            deleteAccount(password, this.state.abort)
                .then(() => {
                    this.props.logout();
                    window.location.href = "/privacy/account-deletion";
                    this.props.closeFunction();
                })
                .catch(error => this.setState({loading: false, errorMessage: error.toString()}))
        });
    }

    componentWillUnmount(): void {
        this.state.abort.abort();
    }
}
